<template>
  <div class="toolbarContainer">
    <div ref="toolbarRef" class="toolbar">
      <!-- 节点操作 -->
      <div class="toolbarBlock">
        <ToolbarNodeBtnList :list="horizontalList" />
      </div>
      <!-- 导出 -->
      <div v-if="false" class="toolbarBlock">
        <div v-if="!isMobile" class="toolbarBtn" @click="openDirectory">
          <span class="icon iconfont icondakai" />
          <span class="text">目录</span>
        </div>
        <!-- 本地文件树 -->
        <div v-if="fileTreeVisible" class="fileTreeBox" :class="{ expand: fileTreeExpand }">
          <div class="fileTreeToolbar">
            <div class="fileTreeName">
              {{ rootDirName ? '/' + rootDirName : '' }}
            </div>
            <div class="fileTreeActionList">
              <div class="btn" :class="[fileTreeExpand ? 'el-icon-arrow-up' : 'el-icon-arrow-down']" @click="fileTreeExpand = !fileTreeExpand" />
              <div class="btn el-icon-close" @click="fileTreeVisible = false" />
            </div>
          </div>
          <div class="fileTreeWrap">
            <el-tree :props="fileTreeProps" :load="loadFileTreeNode" :expand-on-click-node="false" node-key="id" lazy>
              <span slot-scope="{ node, data }" class="customTreeNode">
                <div class="treeNodeInfo">
                  <span class="treeNodeIcon iconfont" :class="[data.type === 'file' ? 'iconwenjian' : 'icondakai']" />
                  <span class="treeNodeName">{{ node.label }}</span>
                </div>
              </span>
            </el-tree>
          </div>
        </div>
      </div>
    </div>
    <NodeImage />
    <!-- <NodeHyperlink />
    <NodeIcon />
    <NodeNote />
    <NodeTag /> -->
  </div>
</template>

<script>
import NodeImage from './NodeImage';
// import NodeHyperlink from './NodeHyperlink';
// import NodeIcon from './NodeIcon';
// import NodeNote from './NodeNote';
// import NodeTag from './NodeTag';
import { mapState } from 'vuex';
import { Notification } from 'element-ui';
import exampleData from 'simple-mind-map/example/exampleData';
import ToolbarNodeBtnList from './ToolbarNodeBtnList.vue';
import { throttle, isMobile } from 'simple-mind-map/src/utils/index';

const fileHandle = null;
export default {
  name: 'Toolbar',
  components: {
    NodeImage,
    // NodeHyperlink,
    // NodeIcon,
    // NodeNote,
    // NodeTag,
    ToolbarNodeBtnList
  },
  data() {
    return {
      isMobile: isMobile(),
      list: [
        'back',
        'forward',
        'painter',
        'siblingNode',
        'childNode',
        'deleteNode',
        'image',
        'icon',
        'link',
        'note',
        'tag',
        'summary',
        'associativeLine',
        'formula',
        // 'attachment',
        'outerFrame',
        'annotation'
      ],
      horizontalList: [],
      verticalList: [],
      showMoreBtn: true,
      popoverShow: false,
      fileTreeProps: {
        label: 'name',
        children: 'children',
        isLeaf: 'leaf'
      },
      fileTreeVisible: false,
      rootDirName: '',
      fileTreeExpand: true,
      waitingWriteToLocalFile: false
    };
  },
  computed: {
    ...mapState({
      isHandleLocalFile: state => state.isHandleLocalFile
    })
  },
  watch: {
    isHandleLocalFile(val) {
      if (!val) {
        Notification.closeAll();
      }
    }
  },
  created() {
    this.$bus.$on('write_local_file', this.onWriteLocalFile);
  },
  mounted() {
    this.computeToolbarShow();
    this.computeToolbarShowThrottle = throttle(this.computeToolbarShow, 300);
    window.addEventListener('resize', this.computeToolbarShowThrottle);
    this.$bus.$on('lang_change', this.computeToolbarShowThrottle);
    window.addEventListener('beforeunload', this.onUnload);
    this.$bus.$on('node_note_dblclick', this.onNodeNoteDblclick);
  },
  beforeDestroy() {
    this.$bus.$off('write_local_file', this.onWriteLocalFile);
    window.removeEventListener('resize', this.computeToolbarShowThrottle);
    this.$bus.$off('lang_change', this.computeToolbarShowThrottle);
    window.removeEventListener('beforeunload', this.onUnload);
    this.$bus.$off('node_note_dblclick', this.onNodeNoteDblclick);
  },
  methods: {
    // 计算工具按钮如何显示
    computeToolbarShow() {
      const windowWidth = window.innerWidth - 40;
      const all = [...this.list];
      let index = 1;
      const loopCheck = () => {
        if (index > all.length) return done();
        this.horizontalList = all.slice(0, index);
        this.$nextTick(() => {
          const width = this.$refs.toolbarRef.getBoundingClientRect().width;
          if (width < windowWidth) {
            index++;
            loopCheck();
          } else if (index > 0 && width > windowWidth) {
            index--;
            this.horizontalList = all.slice(0, index);
            done();
          }
        });
      };
      const done = () => {
        this.verticalList = all.slice(index);
        this.showMoreBtn = this.verticalList.length > 0;
      };
      loopCheck();
    },

    // 监听本地文件读写
    onWriteLocalFile(content) {
      clearTimeout(this.timer);
      if (fileHandle && this.isHandleLocalFile) {
        this.waitingWriteToLocalFile = true;
      }
      this.timer = setTimeout(() => {
        this.writeLocalFile(content);
      }, 1000);
    },

    onUnload(e) {
      if (this.waitingWriteToLocalFile) {
        const msg = '存在未保存的数据';
        e.returnValue = msg;
        return msg;
      }
    },

    // 加载本地文件树
    async loadFileTreeNode(node, resolve) {
      try {
        let dirHandle;
        if (node.level === 0) {
          dirHandle = await window.showDirectoryPicker();
          this.rootDirName = dirHandle.name;
        } else {
          dirHandle = node.data.handle;
        }
        const dirList = [];
        const fileList = [];
        for await (const [key, value] of dirHandle.entries()) {
          const isFile = value.kind === 'file';
          if (isFile && !/\.(smm|xmind|md|json)$/.test(value.name)) {
            continue;
          }
          const enableEdit = isFile && /\.smm$/.test(value.name);
          const data = {
            id: key,
            name: value.name,
            type: value.kind,
            handle: value,
            leaf: isFile,
            enableEdit
          };
          if (isFile) {
            fileList.push(data);
          } else {
            dirList.push(data);
          }
        }
        resolve([...dirList, ...fileList]);
      } catch (error) {
        console.log(error);
        this.fileTreeVisible = false;
        resolve([]);
        if (error.toString().includes('aborted')) {
          return;
        }
        this.$message.warning('toolbar.notSupportTip');
      }
    },

    // 扫描本地文件夹
    openDirectory() {
      this.fileTreeVisible = false;
      this.fileTreeExpand = true;
      this.rootDirName = '';
      this.$nextTick(() => {
        this.fileTreeVisible = true;
      });
    },

    // 渲染读取的数据
    setData(str) {
      try {
        let data = JSON.parse(str);
        if (typeof data !== 'object') {
          throw new Error('toolbar.fileContentError');
        }
        if (data.root) {
          this.isFullDataFile = true;
        } else {
          this.isFullDataFile = false;
          data = {
            ...exampleData,
            root: data
          };
        }
        this.$bus.$emit('setData', data);
      } catch (error) {
        console.log(error);
        this.$message.error('toolbar.fileOpenFailed');
      }
    },

    // 写入本地文件
    async writeLocalFile(content) {
      if (!fileHandle || !this.isHandleLocalFile) {
        this.waitingWriteToLocalFile = false;
        return;
      }
      if (!this.isFullDataFile) {
        content = content.root;
      }
      const string = JSON.stringify(content);
      const writable = await fileHandle.createWritable();
      await writable.write(string);
      await writable.close();
      this.waitingWriteToLocalFile = false;
    },

    onNodeNoteDblclick(node, e) {
      e.stopPropagation();
      this.$bus.$emit('showNodeNote', node);
    }
  }
};
</script>

<style lang="less" scoped>
.toolbarContainer {
  position: fixed;

  .toolbar {
    position: absolute;
    left: 10px;
    top: 10px;
    width: max-content;
    display: flex;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(26, 26, 26, 0.8);
    z-index: 2;

    .toolbarBlock {
      background-color: #fff;
      padding: 10px 20px;
      border-radius: 6px;
      box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.06);
      border: 1px solid rgba(0, 0, 0, 0.06);
      margin-right: 20px;
      flex-shrink: 0;
      position: relative;

      &:last-of-type {
        margin-right: 0;
      }
    }

    .toolbarBtn {
      display: flex;
      justify-content: center;
      flex-direction: column;
      cursor: pointer;
      margin-right: 20px;

      &:last-of-type {
        margin-right: 0;
      }

      &:hover {
        &:not(.disabled) {
          .icon {
            background: #f5f5f5;
          }
        }
      }

      &.active {
        .icon {
          background: #f5f5f5;
        }
      }

      &.disabled {
        color: #bcbcbc;
        cursor: not-allowed;
        pointer-events: none;
      }

      .icon {
        display: flex;
        height: 26px;
        background: #fff;
        border-radius: 4px;
        border: 1px solid #e9e9e9;
        justify-content: center;
        flex-direction: column;
        text-align: center;
        padding: 0 5px;
      }

      .text {
        margin-top: 3px;
      }
    }
  }
}
</style>
